import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar } from '../../components/Navbar';

import FarmShareBG from '../../assets/FarmshareBG.jpg';
import { ContentBox } from '../../components/ContentBox';

const FarmsharePage = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-sky-200">
      <Navbar
        src={FarmShareBG}
        pageName={t('farmshare.navbar.pageName')}
        pageText={t('farmshare.navbar.pageText')}
      />
      <ContentBox
        title={t('farmshare.contentBox.title')}
        content={
          <p>
            {t('farmshare.contentBox.bodyPrefix')}
            <a
              href="https://www.us-ltrcd.org/contact-us"
              target="partner"
              className="text-lime-700 hover:text-emerald-700 hover:underline"
            >
              {t('farmshare.contentBox.rcdLinkText')}
            </a>{' '}
            {t('farmshare.contentBox.bodySuffix')}
          </p>
        }
        bgColor={'#FFFFFF'}
      />
    </div>
  );
};

export { FarmsharePage };
